/*
  Endpoint component - migrated from jwt-bch-frontend
*/

import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Accordion } from 'react-bootstrap'
import Example from './Example'

function Endpoint ({ endpoints, SERVER, VERSION }) {
  const [activeIndex, setActiveIndex] = useState(null)

  const handleToggle = (i) => {
    setActiveIndex(activeIndex === i ? null : i)
  }

  return (
    <Accordion>
      {endpoints.map((val, i) => (
        <Accordion.Item eventKey={i.toString()} key={i}>
          <Accordion.Header onClick={() => handleToggle(i + 1)}>
            <div className='w-100 d-flex justify-content-between align-items-center'>
              <div>
                <span className='badge bg-primary me-2'>{val.type}</span>
                <strong>{VERSION}{val.endpoint}</strong>
                <p className='mb-0 text-muted'>{val.shortDescription}</p>
              </div>
            </div>
          </Accordion.Header>
          <Accordion.Body>
            {activeIndex === i + 1 && (
              <Example data={val} SERVER={SERVER} VERSION={VERSION} />
            )}
          </Accordion.Body>
        </Accordion.Item>
      ))}
    </Accordion>
  )
}

Endpoint.propTypes = {
  endpoints: PropTypes.array,
  SERVER: PropTypes.string,
  VERSION: PropTypes.string
}

export default Endpoint
